import { DropdownListItem, FlexBox } from '@brg/ui';
import { FC } from 'react';
import { InfoItemWrapper } from '../styles';
import { useTranslation } from 'react-i18next';
import useInstantScroll from 'shared/hooks/useSmoothScroll';

type PropsT = {
    name: string;
    tabName?: string;
    href: string;
    order: number;
    isActive: boolean;
    isExam?: boolean;
    isHomeWork?: boolean;
    isDisabled?: boolean;
    showOrderNumber: boolean;
    postId?: string;
}

export const InfoItem: FC<PropsT> = ({
    name,
    href,
    order,
    tabName,
    isActive,
    isExam,
    isHomeWork,
    isDisabled,
    showOrderNumber,
    postId
}) => {
    const {t} = useTranslation();
    const { scrollToElement } = useInstantScroll({
        navbarHeight: 64,
        anchorMenuHeight: 49,
        extraOffset: -40,
        minDuration: 1500,
        maxDuration: 2000,
        scrollSpeed: 1.0,
    });

    if (isDisabled) {
        return (
            <DropdownListItem>
                <InfoItemWrapper isActive={false} className={'theme-name'} style={{ opacity: 0.4, cursor: 'default' }}>
                    {t('project_edit.lms.theme_name', { order, name })}
                </InfoItemWrapper>
            </DropdownListItem>
        );
    }

    if (isExam) return <a className={'item-link'} target='_SELF' href={href} onClick={e => {
        if (postId) scrollToElement(postId);
    }}>
        <DropdownListItem onClick={(ev) => {
            ev.stopPropagation();
        }}>
            <InfoItemWrapper isActive={isActive} className={'theme-name'}>
                {t('project_edit.lms.exam')}
            </InfoItemWrapper>
        </DropdownListItem>
    </a>

    return (
        <a target='_SELF' className={'item-link'} href={href} onClick={e => {
            if (postId) scrollToElement(postId);
        }}>
            <DropdownListItem onClick={(ev) => {
                ev.stopPropagation();
            }}>
                <InfoItemWrapper isActive={isActive} className={'theme-name'}>
                    {tabName ? tabName: (
                        isHomeWork ? ((showOrderNumber ? `${t('project_edit.lms.theme_name', {
                            order,
                            name: t('project_edit.lms.home_work')
                        })}. ` : t('project_edit.lms.home_work'))) : t('project_edit.lms.theme_name', {order, name})
                    )}
                </InfoItemWrapper>
            </DropdownListItem>
        </a>
    )
}import { DropdownListItem, FlexBox } from '@brg/ui';
import { FC } from 'react';
import { InfoItemWrapper } from '../styles';
import { useTranslation } from 'react-i18next';
import useInstantScroll from 'shared/hooks/useSmoothScroll';

type PropsT = {
    name: string;
    tabName?: string;
    href: string;
    order: number;
    isActive: boolean;
    isExam?: boolean;
    isHomeWork?: boolean;
    isDisabled?: boolean;
    showOrderNumber: boolean;
    postId?: string;
}

export const InfoItem: FC<PropsT> = ({
    name,
    href,
    order,
    tabName,
    isActive,
    isExam,
    isHomeWork,
    isDisabled,
    showOrderNumber,
    postId
}) => {
    const {t} = useTranslation();
    const { scrollToElement } = useInstantScroll({
        navbarHeight: 64,
        anchorMenuHeight: 49,
        extraOffset: -40,
        minDuration: 1500,
        maxDuration: 2000,
        scrollSpeed: 1.0,
    });

    if (isDisabled) {
        return (
            <DropdownListItem>
                <InfoItemWrapper isActive={false} className={'theme-name'} style={{ opacity: 0.4, cursor: 'default' }}>
                    {t('project_edit.lms.theme_name', { order, name })}
                </InfoItemWrapper>
            </DropdownListItem>
        );
    }

    if (isExam) return <a className={'item-link'} target='_SELF' href={href} onClick={e => {
        if (postId) scrollToElement(postId);
    }}>
        <DropdownListItem onClick={(ev) => {
            ev.stopPropagation();
        }}>
            <InfoItemWrapper isActive={isActive} className={'theme-name'}>
                {t('project_edit.lms.exam')}
            </InfoItemWrapper>
        </DropdownListItem>
    </a>

    return (
        <a target='_SELF' className={'item-link'} href={href} onClick={e => {
            if (postId) scrollToElement(postId);
        }}>
            <DropdownListItem onClick={(ev) => {
                ev.stopPropagation();
            }}>
                <InfoItemWrapper isActive={isActive} className={'theme-name'}>
                    {tabName ? tabName: (
                        isHomeWork ? ((showOrderNumber ? `${t('project_edit.lms.theme_name', {
                            order,
                            name: t('project_edit.lms.home_work')
                        })}. ` : t('project_edit.lms.home_work'))) : t('project_edit.lms.theme_name', {order, name})
                    )}
                </InfoItemWrapper>
            </DropdownListItem>
        </a>
    )
}